<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <!--     :style="`top:${top}px`" -->
      <v-btn
        :class="className"
        :style="`bottom:${bottom}px`"
        color="primary"
        icon
        small
        v-bind="attrs"
        v-on="on"
        @click="callback"
      >
        <v-icon>mdi-keyboard-backspace</v-icon>
      </v-btn>
    </template>
    <span>返回</span>
  </v-tooltip>
</template>
<script>
  export default {
    props: {
      bottom: {
        type:Number
      },
      className: {
        type:String
      }
    },
    methods: {
      callback() {
        this.$emit('go')
      }
    }
  }
</script>